import React from "react";
import Functions from "./index.funtion";
export default function DashboardHeading(props) {
  const { navigate, activeTab, setActiveTab } = Functions();
  return (
    <div className="flex items-center justify-between">
      <h1 className="text-white xs:text-sm sm:text-xl lg:text-2xl xl:text-3xl font-onestSemiBold">
        {props.title}
      </h1>
      {props.btnText && (
        <div
          className="bg-[#D9A239] cursor-pointer text-secondary xs:text-[6px] sm:text-sm lg:text-base rounded-full xs:px-2 xs:py-[2px] sm:px-3 sm:py-1 lg:px-3 lg:py-2 font-onestRegular transform transition-transform duration-300 hover:scale-105 hover:bg-[#c59632]"
          onClick={() => navigate("/create-job")}
        >
          {props.btnText}
        </div>
      )}
      {props.RequestsBtn && (
        <div className="flex items-center border-[#707070] border gap-x-2 p-1 rounded-full">
          <div
            className={`bg-[#D9A239] cursor-pointer text-secondary xs:text-[6px] sm:text-sm lg:text-base rounded-full xs:px-2 xs:py-[2px] sm:px-3 sm:py-1 lg:px-3 lg:py-3 font-onestRegular transform transition-transform duration-300 hover:scale-105 hover:bg-[#c59632] ${
              activeTab === "pending" ? "bg-[#c59632]" : ""
            }`}
            onClick={() => setActiveTab("pending")}
          >
            Pending Requests
          </div>
          <div
            className={`bg-[#D9A239] cursor-pointer text-secondary xs:text-[6px] sm:text-sm lg:text-base rounded-full xs:px-2 xs:py-[2px] sm:px-3 sm:py-1 lg:px-3 lg:py-3 font-onestRegular transform transition-transform duration-300 hover:scale-105 hover:bg-[#c59632] ${
              activeTab === "approved" ? "bg-[#c59632]" : ""
            }`}
            onClick={() => setActiveTab("approved")}
          >
            Approved Requests
          </div>
        </div>
      )}
    </div>
  );
}
